
import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const countryPhoneCodes = [
  { value: '+93', label: 'AF (+93)' },
  { value: '+355', label: 'AL (+355)' },
  { value: '+213', label: 'DZ (+213)' },
  { value: '+54', label: 'AR (+54)' },
  { value: '+374', label: 'AM (+374)' },
  { value: '+61', label: 'AU (+61)' },
  { value: '+43', label: 'AT (+43)' },
  { value: '+994', label: 'AZ (+994)' },
  { value: '+973', label: 'BH (+973)' },
  { value: '+880', label: 'BD (+880)' },
  { value: '+375', label: 'BY (+375)' },
  { value: '+32', label: 'BE (+32)' },
  { value: '+55', label: 'BR (+55)' },
  { value: '+673', label: 'BN (+673)' },
  { value: '+359', label: 'BG (+359)' },
  { value: '+855', label: 'KH (+855)' },
  { value: '+237', label: 'CM (+237)' },
  { value: '+1', label: 'US/CA (+1)' },
  { value: '+56', label: 'CL (+56)' },
  { value: '+86', label: 'CN (+86)' },
  { value: '+57', label: 'CO (+57)' },
  { value: '+506', label: 'CR (+506)' },
  { value: '+385', label: 'HR (+385)' },
  { value: '+53', label: 'CU (+53)' },
  { value: '+357', label: 'CY (+357)' },
  { value: '+420', label: 'CZ (+420)' },
  { value: '+45', label: 'DK (+45)' },
  { value: '+593', label: 'EC (+593)' },
  { value: '+20', label: 'EG (+20)' },
  { value: '+372', label: 'EE (+372)' },
  { value: '+251', label: 'ET (+251)' },
  { value: '+358', label: 'FI (+358)' },
  { value: '+33', label: 'FR (+33)' },
  { value: '+995', label: 'GE (+995)' },
  { value: '+49', label: 'DE (+49)' },
  { value: '+233', label: 'GH (+233)' },
  { value: '+30', label: 'GR (+30)' },
  { value: '+502', label: 'GT (+502)' },
  { value: '+852', label: 'HK (+852)' },
  { value: '+36', label: 'HU (+36)' },
  { value: '+354', label: 'IS (+354)' },
  { value: '+91', label: 'IN (+91)' },
  { value: '+62', label: 'ID (+62)' },
  { value: '+98', label: 'IR (+98)' },
  { value: '+964', label: 'IQ (+964)' },
  { value: '+353', label: 'IE (+353)' },
  { value: '+972', label: 'IL (+972)' },
  { value: '+39', label: 'IT (+39)' },
  { value: '+81', label: 'JP (+81)' },
  { value: '+962', label: 'JO (+962)' },
  { value: '+7', label: 'KZ (+7)' },
  { value: '+254', label: 'KE (+254)' },
  { value: '+965', label: 'KW (+965)' },
  { value: '+996', label: 'KG (+996)' },
  { value: '+856', label: 'LA (+856)' },
  { value: '+371', label: 'LV (+371)' },
  { value: '+961', label: 'LB (+961)' },
  { value: '+370', label: 'LT (+370)' },
  { value: '+352', label: 'LU (+352)' },
  { value: '+853', label: 'MO (+853)' },
  { value: '+60', label: 'MY (+60)' },
  { value: '+52', label: 'MX (+52)' },
  { value: '+976', label: 'MN (+976)' },
  { value: '+212', label: 'MA (+212)' },
  { value: '+95', label: 'MM (+95)' },
  { value: '+977', label: 'NP (+977)' },
  { value: '+31', label: 'NL (+31)' },
  { value: '+64', label: 'NZ (+64)' },
  { value: '+234', label: 'NG (+234)' },
  { value: '+850', label: 'KP (+850)' },
  { value: '+47', label: 'NO (+47)' },
  { value: '+968', label: 'OM (+968)' },
  { value: '+92', label: 'PK (+92)' },
  { value: '+507', label: 'PA (+507)' },
  { value: '+51', label: 'PE (+51)' },
  { value: '+63', label: 'PH (+63)' },
  { value: '+48', label: 'PL (+48)' },
  { value: '+351', label: 'PT (+351)' },
  { value: '+974', label: 'QA (+974)' },
  { value: '+40', label: 'RO (+40)' },
  { value: '+7 ', label: 'RU (+7)' },
  { value: '+966', label: 'SA (+966)' },
  { value: '+381', label: 'RS (+381)' },
  { value: '+65', label: 'SG (+65)' },
  { value: '+421', label: 'SK (+421)' },
  { value: '+386', label: 'SI (+386)' },
  { value: '+27', label: 'ZA (+27)' },
  { value: '+82', label: 'KR (+82)' },
  { value: '+34', label: 'ES (+34)' },
  { value: '+94', label: 'LK (+94)' },
  { value: '+46', label: 'SE (+46)' },
  { value: '+41', label: 'CH (+41)' },
  { value: '+886', label: 'TW (+886)' },
  { value: '+66', label: 'TH (+66)' },
  { value: '+90', label: 'TR (+90)' },
  { value: '+256', label: 'UG (+256)' },
  { value: '+380', label: 'UA (+380)' },
  { value: '+971', label: 'AE (+971)' },
  { value: '+44', label: 'UK (+44)' },
  { value: '+598', label: 'UY (+598)' },
  { value: '+998', label: 'UZ (+998)' },
  { value: '+58', label: 'VE (+58)' },
  { value: '+84', label: 'VN (+84)' },
];

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  name?: string;
  id?: string;
  className?: string;
  disabled?: boolean;
  countryCodeName?: string;
  phoneNumberName?: string;
  placeholder?: string;
}

export function PhoneInput({
  value,
  onChange,
  name,
  id,
  className,
  disabled,
  countryCodeName,
  phoneNumberName,
  placeholder = ''
}: PhoneInputProps) {
  // Enhanced parsing to handle various phone number formats
  const [countryCode, localNumber] = React.useMemo(() => {
    if (!value) return ['+1', ''];
    
    // Handle properly formatted numbers like "+1 9099057788"
    const properFormatMatch = value.match(/^(\+\d+)\s+(.*)$/);
    if (properFormatMatch) {
      return [properFormatMatch[1], properFormatMatch[2]];
    }
    
    // Handle numbers that start with + but no space like "+19099057788"
    const nospaceMatch = value.match(/^(\+\d{1,4})(.*)$/);
    if (nospaceMatch) {
      return [nospaceMatch[1], nospaceMatch[2]];
    }
    
    // Handle legacy formats like "19099057788" (assume US/CA)
    if (value.match(/^1\d{10}$/)) {
      return ['+1', value.substring(1)];
    }
    
    // Handle 10-digit US numbers like "9099057788"
    if (value.match(/^\d{10}$/)) {
      return ['+1', value];
    }
    
    // Default fallback
    return ['+1', value];
  }, [value]);

  const handleCountryCodeChange = (newCode: string) => {
    onChange(`${newCode} ${localNumber}`);
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newNumber = e.target.value;
    onChange(`${countryCode} ${newNumber}`);
  };

  return (
    <div className={`flex gap-2 ${className || ''}`}>
      <Select value={countryCode} onValueChange={handleCountryCodeChange} disabled={disabled}>
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="Code" />
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {countryPhoneCodes.map((code) => (
            <SelectItem key={code.value} value={code.value}>
              {code.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        type="tel"
        value={localNumber}
        onChange={handleNumberChange}
        placeholder={placeholder}
        className="flex-1"
        name={name || phoneNumberName}
        id={id}
        disabled={disabled}
        autoComplete="tel"
      />
    </div>
  );
}
